import { CountryNumberPrefix } from 'utils/constants'
import reduce from 'lodash/reduce'

const getQuestionResponse = (questions, details) => {
  return questions.reduce((acc, { questionOrder, questionType, questionText: question }) => {
    const response = details[`question${questionOrder}`]
    if (!response) {
      return acc
    }

    return [...acc, {
      questionOrder,
      questionType,
      question,
      response
    }]
  }, [])
}

const createPostDetailsRequest = ({
  property,
  config,
  details,
  countryCode
}) => {
  const {
    cesAppId,
    integratorId,
    questions,
    userMonthlyLimit: userLimit
  } = config
  const {
    propertyId,
    propertyAddress: formattedAddress
  } = property
  const {
    firstName: customerFirstName,
    lastName: customerLastName,
    email: customerEmail,
    mobileNumber
  } = details

  return {
    integratorId,
    cesAppId,
    customerFirstName,
    customerLastName,
    customerEmail,
    customerContactNumber: CountryNumberPrefix[countryCode] + mobileNumber,
    customerCountryCode: countryCode,
    property: {
      propertyId,
      formattedAddress
    },
    userLimit,
    questions: getQuestionResponse(questions, details)
  }
}

const createSendVerificationRequest = ({
  config,
  details,
  countryCode
}) => {
  const {
    cesAppId,
    integratorId,
    userMonthlyLimit: userLimit
  } = config
  const { mobileNumber, email } = details
  return {
    integratorId,
    cesAppId,
    phoneNumber: CountryNumberPrefix[countryCode] + mobileNumber,
    countryCode,
    email,
    userLimit
  }
}

const createVerifyCodeRequest = (details, code) => {
  code = reduce(code, (acc, v) => acc + v, '')

  return {
    details,
    verification: {
      code
    }
  }
}

const getReportPreviewUrl = (integratorShortName) => {
  const { protocol, host } = window.location
  return `${protocol}//${host}/preview/${integratorShortName}`
}

export {
  createPostDetailsRequest,
  createSendVerificationRequest,
  createVerifyCodeRequest,
  getReportPreviewUrl
}
